import getFile from './getFile'
import ERROR_CODES from './../lib/errorCodes'
import flattenSchema from '@rwitl/reformed-util/lib/flattenSchema'

var getSchema = async function(token, branchId){

  try {
   var file = await getFile(token, branchId, 'src/schema.js')
  } catch (err){
    // Make the error code more specific
    if (err.code == ERROR_CODES.GRAPHQL_FILE_NOT_FOUND){
      err.message = `The schema was not found in the repository for the selected
        branch at the
        expected location "src/schema.js".`.replace(/\s+/g, ' ')
      err.code = ERROR_CODES.GRAPHQL_SCHEMA_FILE_NOT_FOUND
    }
    throw err
  }
  return file
}

export default getSchema



// WEBPACK FOOTER //
// ./src/data/getSchema.js